import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';
import TrendingUpRoundedIcon from '@material-ui/icons/TrendingUpRounded';
import WavesIcon from '@material-ui/icons/Waves';
import SpeedIcon from '@material-ui/icons/Speed';
import BugReportIcon from '@material-ui/icons/BugReport';
import AssessmentIcon from '@material-ui/icons/Assessment';
import Settings from '@material-ui/icons/Settings';
import ListAltIcon from '@material-ui/icons/ListAlt';
import Devices from '@material-ui/icons/Devices';
import DatasetOutlinedIcon from '@mui/icons-material/DatasetOutlined';

const pageAccessObj = [
    {
      pageName: 'Web Test Execution',
      path: '/',
      isAllowed: false,
      key: 'test_execution',
      group: 'automation',
      icon: [<SpeedIcon></SpeedIcon>],
    },
    {
      pageName: 'APP Test Execution',
      path: '/AppExecution',
      isAllowed: false,
      key: 'app_execution',
      group: 'automation',
      icon: [<Devices></Devices>],
    },
    {
      pageName: 'API Test Execution',
      path: '/ApiExecution',
      isAllowed: false,
      key: 'api_execution',
      group: 'automation',
      icon: [<ListAltIcon></ListAltIcon>],
    },
    {
      pageName: 'Currently Executing',
      path: '/CurrentExecution',
      isAllowed: false,
      key: 'currently_executing',
      group: 'automation',
      icon: [<WavesIcon />],
    },
    {
      pageName: 'Queue',
      path: '/Queue',
      isAllowed: false,
      key: 'queue',
      group: 'automation',
      icon: [<FormatListNumberedIcon></FormatListNumberedIcon>],
    },
    {
      pageName: 'Results',
      path: '/Results',
      isAllowed: false,
      key: 'results',
      group: 'automation',
      icon: [<AssessmentIcon></AssessmentIcon>],
    },
    {
      pageName: 'Automation Analytics',
      path: '/Trends',
      isAllowed: false,
      key: 'trends',
      group: 'automation',
      icon: [<TrendingUpRoundedIcon></TrendingUpRoundedIcon>],
    },
    {
      pageName: 'Defect Analytics',
      path: '/defecttrends',
      isAllowed: false,
      key: 'defecttrends',
      group: 'automation',
      icon: [<BugReportIcon></BugReportIcon>]
    },
    {
      pageName: 'RTM Settings',
      path: '/RTMSettings',
      isAllowed: false,
      key: 'rtm_settings',
      group: 'rtm',
      icon: [<Settings></Settings>],
    },
    {
      pageName: 'RTM Mappings',
      path: '/RTMMappings',
      isAllowed: false,
      key: 'rtm_mappings',
      group: 'rtm',
      icon: [<DatasetOutlinedIcon></DatasetOutlinedIcon>],
    }
  ];
export default pageAccessObj